import type { VatMode } from '@crm/shared'
import { apiClient } from './client'

export interface QuotationItem {
  itemId: string
  partNumber: string
  /** Оригинальный артикул заказчика — для колонки «Артикул заказчика» в КП. */
  customerPartNumber?: string | null
  brand: string | null
  quantity: number
  unit: string | null
  cost: number
  matrix: string
  markup: number
  priceWithMarkup: number
  /** Цена без НДС до копейки — только в КП «НДС сверху». */
  priceNet?: number
  supplierName?: string | null
  /** «Примечание к КП» по позиции — в столбце «Примечание» деталей КП и в файле. */
  note?: string | null
}

export interface QuotationSnapshot {
  id: string
  createdAt: string
  requestNumber: string | null
  totalSum: number
  /** Режим НДС КП (с 15.10.2026); у старых КП сервер отдаёт «С НДС». */
  vatMode?: VatMode
  markups: Record<string, number>
  positionOverrides: Record<string, number>
  exchangeRates?: Record<string, number>
  markupConstants?: Record<string, number>
  items?: QuotationItem[]
  // createdBy = null если автор удалён (миграция 20260512000001, onDelete: SetNull).
  // В UI показывается «удалённый пользователь».
  createdBy: { id: string; email: string; name: string | null } | null
  /** Сколько позиций из этого КП оформлено «В заказ» (status=ORDERED). */
  orderedCount?: number
}

export async function getQuotations(requestId: string): Promise<QuotationSnapshot[]> {
  const { data } = await apiClient.get<{ data: QuotationSnapshot[] }>(
    `/requests/${requestId}/quotations`,
  )
  return data.data
}

export async function getQuotationDetail(id: string): Promise<QuotationSnapshot> {
  const { data } = await apiClient.get<{ data: QuotationSnapshot }>(`/quotations/${id}`)
  return data.data
}

export async function deleteQuotation(id: string): Promise<void> {
  await apiClient.delete(`/quotations/${id}`)
}

export async function createQuotation(
  requestId: string,
  body: {
    requestNumber?: string | null
    exchangeRates: Record<string, number>
    markupConstants: Record<string, number>
    markups: Record<string, number>
    positionOverrides: Record<string, number>
    items: QuotationItem[]
    totalSum: number
    vatMode: VatMode
  },
): Promise<QuotationSnapshot> {
  const { data } = await apiClient.post<{ data: QuotationSnapshot }>(
    `/requests/${requestId}/quotations`,
    body,
  )
  return data.data
}
